import Cookies from 'js-cookie'
import { createSendRpc } from '_src/utils/w3'
import { getNonce, authSign, verifySignExpire } from '_src/servers/v1/auth'

import store from '_src/store'

const EIP712Domain = [
  { name: 'name', type: 'string' },
  { name: 'version', type: 'string' },
  // { name: 'chainId', type: 'uint256' },
  { name: 'verifyingContract', type: 'address' },
  { name: 'salt', type: 'bytes32' },
]

// 登录签名
export async function loginSign({ web3, address, nonce }) {
  const tranAddress = web3.utils.toChecksumAddress(address)
  const message = `Welcome to iNFTspace!\n\nClick to sign in and accept the iNFTspace Terms of Service: https://inftspaceworld.gitbook.io/terms-of-service\n\nThis request will not trigger a blockchain transaction or cost any gas fees.\n\nWallet address:${tranAddress}\n\nNonce:${nonce}\n\n`

  try {
    const from = tranAddress
    const msg = `0x${Buffer.from(message, 'utf8').toString('hex')}`
    const sendRpc = createSendRpc(web3.currentProvider)
    const sign = await sendRpc({
      method: 'personal_sign',
      params: [msg, from],
      jsonrpc: '2.0',
      id: new Date().getTime(),
    })

    return new Promise((resolve) => {
      if (sign?.result) {
        resolve(sign.result)
      } else {
        resolve('')
      }
    })
  } catch (error) {
    // 失败的回调函数
    return new Promise((resolve, reject) => {
      console.error(error)
      reject(error)
    })
  }
}

// 交易签名
export async function transactionSign({ web3, minterAddress, nonce, domainData, functionSignature }) {
  const msgParams = {
    types: {
      EIP712Domain: [
        { name: 'name', type: 'string' },
        { name: 'version', type: 'string' },
        { name: 'verifyingContract', type: 'address' },
        { name: 'salt', type: 'bytes32' },
      ],
      MetaTransaction: [
        { name: 'nonce', type: 'uint256' },
        { name: 'from', type: 'address' },
        { name: 'functionSignature', type: 'bytes' },
      ],
    },
    primaryType: 'MetaTransaction',
    domain: domainData,
    message: {
      nonce,
      from: minterAddress,
      functionSignature,
    },
  }

  const sendRpc = createSendRpc(web3.currentProvider)

  try {
    const sign = await sendRpc({
      method: 'eth_signTypedData_v3',
      params: [minterAddress, JSON.stringify(msgParams)],
      jsonrpc: '2.0',
      id: new Date().getTime(),
    }).catch((error) => {
      if (error.code === 4001) {
        return new Promise((resolve, reject) => {
          reject(error)
        })
      }
    })

    return new Promise((resolve) => {
      if (sign?.result) {
        const signature = sign.result
        let sig_r = signature.slice(2, 66)
        let sig_s = signature.slice(66, 130)
        let sig_v = `0x${signature.slice(130, 132)}`

        sig_v = parseInt(sig_v)
        if (![27, 28].includes(sig_v)) sig_v += 27

        resolve({
          sig_r,
          sig_s,
          sig_v,
        })
      } else {
        resolve({})
      }
    })
  } catch (error) {
    // 失败的回调函数
    return new Promise((resolve, reject) => {
      console.log(error)
      reject({})
    })
  }
}

// 登录签名
export async function login() {
  const { global, wallet } = store.getState()
  const { address } = global
  const { web3 } = wallet
  try {
    if (address) {
      var res = await getNonce({ address })
    }
    if (res && res.code == 1000) {
      const {
        data: { nonce },
      } = res
      const signature = await loginSign({ web3, address, nonce }).catch((error) => {
        console.log(error)
        return new Promise((resolve, reject) => {
          reject(false)
        })
      })
      if (signature) {
        const result = await authSign({ address, signature }).catch((error) => {
          console.log(error)
          return new Promise((resolve, reject) => {
            reject(false)
          })
        })
        return new Promise((resolve) => {
          if (result && result.code == 1000) {
            const {
              data: { access_token },
            } = result
            Cookies.set('access_token', access_token, { expires: 365 })
            resolve(true)
          }
        })
      }
    }
  } catch (error) {
    return new Promise((resolve, reject) => {
      console.error(error)
      reject(false)
    })
  }
}

export async function verifySignStatus() {
  const access_token = Cookies.get('access_token') || ''
  if (access_token) {
    const expire = await verifySignExpire({})
    // 1300 状态码的时候 http 会拦截 进行签名
    // 1000 状态码的时候 表示 token 正常

    return new Promise((resolve) => {
      if (expire && expire?.code == 1000) {
        resolve(true)
      } else if (expire && expire?.code == 1300) {
        resolve(false)
      }
    })
  } else {
    const res = await login().catch((error) => {
      return new Promise((resolve, reject) => {
        reject(error)
      })
    })

    return new Promise((resolve) => {
      resolve(res)
    })
  }
}

// 2.8交易签名
export async function signTypedData({ web3, address, domain, Order, message }) {
  const msgParams = {
    types: {
      EIP712Domain,
      Order,
    },
    primaryType: 'Order',
    domain,
    message,
  }

  const sendRpc = createSendRpc(web3.currentProvider)

  try {
    const sign = await sendRpc({
      method: 'eth_signTypedData_v3',
      params: [address, JSON.stringify(msgParams)],
      jsonrpc: '2.0',
      id: new Date().getTime(),
    }).catch((error) => {
      if (error.code === 4001) {
        return new Promise((resolve, reject) => {
          reject(error)
        })
      }
    })

    return new Promise((resolve) => {
      if (sign?.result) {
        const signature = sign.result
        let sig_r = signature.slice(2, 66)
        let sig_s = signature.slice(66, 130)
        let sig_v = `0x${signature.slice(130, 132)}`

        sig_v = parseInt(sig_v)
        if (![27, 28].includes(sig_v)) sig_v += 27

        resolve({
          signature,
          sig_r,
          sig_s,
          sig_v,
        })
      } else {
        resolve('')
      }
    })
  } catch (error) {
    // 失败的回调函数
    return new Promise((resolve, reject) => {
      console.log(error)
      reject({})
    })
  }
}
